/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React from 'react';
import ReactDOM from 'react-dom';

const DialogWrapper = {
	show: function( dialogClass, options ) {
		let container = document.querySelector('.dialogWrapper');
		if ( !container ) {
			container = document.body.appendChild( document.createElement('DIV') );
			container.className = 'dialogWrapper';
		}
		const externalCloseCallback = options.onCloseDialog;
		const props = {
			...options,
			ref: (instance) => { if ( instance ) instance.openDialog(); },
			onCloseDialog: () => {
				ReactDOM.unmountComponentAtNode( container );
				if ( externalCloseCallback ) {
					externalCloseCallback();
				}
			}
		};

		ReactDOM.render( React.createElement( dialogClass, props ), container );
	}
};
export default DialogWrapper;


// WEBPACK FOOTER //
// ./src/js/utilities/DialogWrapper.js